export class DeleteBusinessAccountModel {
    id: string;
}